module.exports = __webpack_public_path__ + "img/img_manual2_5.f65f15b1.jpg";